module.exports = __webpack_public_path__ + "img/statusNoti.200856c4.svg";